import { render } from "./MessageGroupDeleteConfirmation.vue?vue&type=template&id=0ba16f8a&scoped=true&ts=true"
import script from "./MessageGroupDeleteConfirmation.vue?vue&type=script&lang=ts"
export * from "./MessageGroupDeleteConfirmation.vue?vue&type=script&lang=ts"

import "./MessageGroupDeleteConfirmation.vue?vue&type=style&index=0&id=0ba16f8a&lang=sass&scoped=true"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ba16f8a"]])

export default __exports__